<template>
  <div class="district-action-box">
    <el-dialog
      :title="title"
      :visible.sync="dialogVisible"
      :width="(activeName ==='four' ? '800px' : '600px')"
      :before-close="handleClose"
      :close-on-click-modal="false"
      class="el-dialogs"
    >
      <el-row>
        <el-col style=" padding:0px 20px;">
          <el-tabs v-model="activeName" @tab-click="handleClick" @change="changeChartData">
            <el-tab-pane label="基础配置" name="first"></el-tab-pane>
            <el-tab-pane label="充值配置" name="second"></el-tab-pane>
            <el-tab-pane label="用户配置" name="third"></el-tab-pane>
            <el-tab-pane label="落地页配置" name="four"></el-tab-pane>
          </el-tabs>
          <el-row>
            <!-- 基础配置 -->
            <el-col v-if=" activeName=='first'">
              <BaseCfg :querry="querry" :roleList="roleList" @editPage="editPage" ref="baseCfg" />
            </el-col>
            <!-- 充值配置 line-->
            <el-col v-if="activeName=='second' ">
              <RechargeCfg
                :querry="querry"
                :rechargeTime="rechargeTime"
                @editPage="editPage"
                ref="rechargeCfg"
              />
            </el-col>
            <!-- 用户配置 line1-->
            <el-col v-if=" activeName=='third'">
              <UserCfg :querry="querry" :userTime="userTime" @editPage="editPage" ref="userCfg" />
            </el-col>
            <!-- 落地页配置 -->
            <el-col v-if="activeName=='four'">
              <LsdyCfg :querry="querry" @editPage="editPage" :activeName="activeName" />
            </el-col>
          </el-row>
        </el-col>
      </el-row>
    </el-dialog>
  </div>
</template>
<script>
import moment from "moment";
import BaseCfg from "./components/baseCfg.vue";
import LsdyCfg from "./components/ldyCfg.vue";
import RechargeCfg from "./components/rechargeCfg.vue";
import UserCfg from "./components/userCfg.vue";
import { changeDate } from "@/utils/global";
import API from "@/api";
export default {
  data() {
    return {
      querry: "",
      activeName: "first",
      dialogVisible: false,
      roleList: [], //基础配置中的role列表
      userTime: "", //用户扣量时间
      rechargeTime: "", //充值扣量时间
      // 弹窗标题
      title: "",
      // 提交按钮状态
      flag: false,
    };
  },
  components: { BaseCfg, LsdyCfg, UserCfg, RechargeCfg },
  mounted() {
    this.currentStarteTime = moment().format().slice(0, 10) + "T00:00:00+08:00";
    this.currentEndTsime =
      moment(moment().format()).add(1, "days").format().slice(0, 10) +
      "T00:00:00+08:00";
  },
  methods: {
    //选项卡切换
    // eslint-disable-next-line no-unused-vars
    handleClick(tab, event) {
      this.changeChartData(); // 切换到扣消费/扣用户页面，加载echart图
    },
    changeChartData() {
      switch (this.activeName) {
        case "first":
          break;
        case "second":
          this.$nextTick(() => {
            this.$refs.rechargeCfg.rechgChartData();
          });
          break;
        case "third":
          this.$nextTick(() => {
            this.$refs.userCfg.userChartData();
          });
          break;
        case "four":
          break;
      }
    },
    //   调用父组件获取列表方法
    editPage() {
      this.$emit("handlerDistrictList");
    },

    //基础配置--获取role列表
    getAuthorList() {
      API.getRoleList({
        discCode: this.querry.parent ? this.querry.parent : "ZERO_VALUE", //商区码 [必传]
        pageNumber: 1, //当前页 [必传]
        pageSize: 10, //每页条数 [必传]
      }).then((res) => {
        if (res.code === 200 && res.data.list) {
          this.roleList = res.data.list;
        }
      });
    },
    // 打开编辑视频弹窗、传递需要编辑的参数
    open(data) {
      this.querry = data;
      this.title = `【商区${data.districtCode}】编辑`;
      this.dialogVisible = true;
      //充值 采集时间判断是否为空 && 充值扣量非空判断
      this.rechargeTime = [];
      if (
        data.rechargeAnalysis.startTime === "0001-01-01T00:00:00Z" &&
        data.rechargeAnalysis.endTime === "0001-01-01T00:00:00Z"
      ) {
        this.rechargeTime.push(this.currentStarteTime);
        this.rechargeTime.push(this.currentEndTsime);
      } else {
        this.rechargeTime.push(changeDate(data.rechargeAnalysis.startTime));
        this.rechargeTime.push(changeDate(data.rechargeAnalysis.endTime));
      }
      if (data.rechgDedAt.slice(0, 4) == "0001") {
        data.rechgDedAt = this.currentEndTsime;
      }

      //用户采集时间判断是否为空 &&用户扣量非空判断
      this.userTime = [];
      if (
        data.nuDedAnalysis.startTime === "0001-01-01T00:00:00Z" &&
        data.nuDedAnalysis.endTime === "0001-01-01T00:00:00Z"
      ) {
        this.userTime.push(this.currentStarteTime);
        this.userTime.push(this.currentEndTsime);
      } else {
        this.userTime.push(changeDate(data.nuDedAnalysis.startTime));
        this.userTime.push(changeDate(data.nuDedAnalysis.endTime));
      }
      if (data.nuDedAt.slice(0, 4) == "0001") {
        data.nuDedAt = this.currentEndTsime;
      }

      //每次打开编辑页 强制展示基础配置tag
      this.activeName = "first";
      this.getAuthorList();
    },
    handleClose() {
      this.dialogVisible = false;
    },
  },
};
</script>

<style lang="scss" scoped>
.district-action-box {
  .checked {
    margin-left: 10px;
  }
  .avatar-uploader {
    width: 150px;
    height: 150px;
  }
  .page-box {
    margin-top: 35px;
    position: relative;
    height: 40px;
  }
  .el-pagination {
    margin-top: 0 !important;
  }
  .p_row {
    color: gray;
    margin-top: 10px;
    margin: 0 6px;
    width: 460px !important;
    display: flex;
    justify-content: space-between;
    .sp {
      color: #000000;
    }
    span {
      margin-right: 15px;
    }
  }
}
</style>
